module.exports = __webpack_public_path__ + "img/k1.2f0044f6.jpg";